import { tradePlayersUseCase } from '@/domain/use-cases/trade-team-league-players.use-case';
import { Result } from '@/entities/Result';
import { TeamLeagueAddPlayerResponse } from '@/entities/TeamLeagueAddPlayer';

export const tradeTeamLeaguePlayersController = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	teamUuid: string,
	playersLeavingTeam: string[],
	playersJoiningTeam: string[],
	receivingTeamUuid: string
): Promise<Result<TeamLeagueAddPlayerResponse>> => {
	return tradePlayersUseCase(organizationUuid, teamLeagueUuid, teamUuid, playersLeavingTeam, playersJoiningTeam, receivingTeamUuid);
};
